var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMoreEpisodes = function SvgMoreEpisodes(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75 1.5V2.87496H4.25V0.625C4.25 0.279822 4.52982 0 4.875 0H14.875C15.2202 0 15.5 0.279822 15.5 0.625V7.5C15.5 7.84518 15.2202 8.125 14.875 8.125H12.5V6.625H14V1.5H5.75ZM2 11V5.875H10.25V11H2ZM0.5 5C0.5 4.65482 0.779822 4.375 1.125 4.375H11.125C11.4702 4.375 11.75 4.65482 11.75 5V11.875C11.75 12.2202 11.4702 12.5 11.125 12.5H1.125C0.779822 12.5 0.5 12.2202 0.5 11.875V5Z",
    fill: "#12100B"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMoreEpisodes, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/more_episodes.631da5ba.svg";
export { ForwardRef as ReactComponent };